import React, {useEffect, useState} from "react";
import {createPortal} from "react-dom";
import {useSelector} from "react-redux";
import ContentSelector from "../../redux/reducers/contents/action";


// declare an interface props
interface AnnotationProps {
    containerId: string,
}

const Annotation = (props: AnnotationProps) => {

    const [showDetail, setShowDetail] = useState(false);

    const power = useSelector(ContentSelector.getLastPower(props.containerId.toUpperCase()))

    return createPortal(
        (
            <div className={"annotation-container"}>
                <div className="annotation-content">
                    <h4>{props.containerId.toUpperCase()}</h4>
                    <p>Observed power: <b>{power?.observed}kW</b></p>
                    <p>Physical model: <b>570.1kW</b></p>
                    <p>Data model: <b>{power?.model}kW</b></p>
                    <i className="annotation-detail-icon fa-solid fa-circle-info"
                       onClick={() => {setShowDetail(!showDetail)}}
                    ></i>
                </div>
                <div className={"detail-annotation" + (showDetail ? ' toggle' : '')}>
                    <div className="detail-content annotation-content">
                        <h5>Pitch Angles</h5>
                        <p>Blade 1: <b>114.0&#8451;</b></p>
                        <p>Blade 2: <b>115.7&#8451;</b></p>
                        <p>Blade 3: <b>111.0&#8451;</b></p>
                        <p>Yaw: <b>5.05&#8451;</b></p>
                    </div>
                    <div className="detail-content annotation-content">
                        <h5>Temperatures</h5>
                        <p>Gear box: <b>43.6&#8451; C</b></p>
                        <p>Generator: <b>45.0&#8451; C</b></p>
                        <p>Nacelle: <b>29.9&#8451; C</b></p>
                    </div>
                    <div className="detail-content annotation-content">
                        <h5>Wind Data</h5>
                        <p>Direction: <b>-2.6&#8451;</b></p>
                        <p>Speed: <b>5.4 km/h</b></p>
                    </div>
                </div>
            </div>
        ),
        document.getElementById(props.containerId)!
    )
}


const AnnotationContainer = () => {

    const [isLoaded, setIsLoaded] = useState(false);

    const [annoList, setAnnoList] = useState<string[]>([]);

    const wind = useSelector(ContentSelector.getWind);

    useEffect(() => {
        window.addEventListener('complete', () => {
            const annoList = Array.from(document.querySelectorAll('.v3d-annotation')).map((el) => el.id);
            setIsLoaded(true);
            setAnnoList(annoList)
            // @ts-ignore
            window.v3d.puzzles.procedures.setRotate(wind);
        })
    }, [])

    return (
        <>
            {isLoaded ? annoList.map(id => <Annotation containerId={id} key={id}/>) : ''}
        </>
    )
}

export default AnnotationContainer;
